import * as HttpService from './http.service';
import * as URL from './url.service';

export const updateBulkSchedule = (updateData, resourceData) => HttpService.putWithAuth(URL.UPDATE_BULK_SCHEDULE_URL, { updateData, resourceData });
